import { render } from "./viewed.vue?vue&type=template&id=1a929e84"
import script from "./viewed.vue?vue&type=script&lang=js"
export * from "./viewed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__